import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { TYPEMODULE, LoaderService, NotificationService, UtilityService, ErrorService, TYPEMESSAGE, ICONS, ACTIONS, EVENTO, CONSTANT, TOOLTIPS, GridDataSource } from '../../../../shared/session/index';
import { DocumentoService } from '../shared/documento.service';
import { PageEvent, MatPaginator, MatTableDataSource } from '@angular/material';
import { SectionBarComponent } from 'src/app/shared/sectionbar/sectionbar.component';
import { Documento, Idocumento } from '../shared/documento.model';

@Component({
  selector: 'app-documento-list',
  // styleUrls: ['table-basic-example.css'],
  templateUrl: 'documento-list.component.html',
})

export class DocumentoListComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @ViewChild(SectionBarComponent) sectionBarComponent: SectionBarComponent;
  @Input() typeModule: TYPEMODULE;
  @Input() titlePage: string;
  @Input() data: any;

  pageSize: number;
  pageEvent: PageEvent;
  displayedColumns: string[];
  dataSource: GridDataSource;
  msgErrorGet: string;
  selectedRowIndex: number = -1;
  buttonGroup: any;
  showMessageGridEmpty: boolean = false;
  pageSizeOptions: number[] = CONSTANT.pageSizeOptions;
  dataAddButton: any;

  constructor(private loaderService: LoaderService, private documentoService: DocumentoService,
    private errorService: ErrorService, private notificationService: NotificationService,
    private utilityService: UtilityService
  ) { }

  ngOnInit() {
    this.pageSize = CONSTANT.pageSize;
    this.pageEvent = new PageEvent();
    this.clearMatPaginator();
    this.displayedColumns = ['ID', 'descripcion', 'ruta', 'status'];
    this.msgErrorGet = 'Error al listar Documentos';
    this.buttonGroup = [
      { tooltip: TOOLTIPS.new, icon: ICONS.new, action: ACTIONS.new }
    ];
    this.dataAddButton = { icon: ICONS.add, nameButton: "AGREGAR DOCUMENTO", action: ACTIONS.new };
  }

  handleRowClick(row: any) {
    this.selectedRowIndex = row.ID;
    this.data.documento = { ID: row.documentoID, Name: row.nombre };
    this.changeEvent({ evento: EVENTO.consultarDocumento, data: this.data });
  }

  private clearMatPaginator() {
    this.pageEvent.pageIndex = 0;
    this.pageEvent.pageSize = this.pageSize;
    this.pageEvent.length = 0;
  }

  private setMatPaginator() {
    this.paginator.length = this.pageEvent.length;
    this.paginator.pageIndex = this.pageEvent.pageIndex;
    this.paginator.pageSize = this.pageEvent.pageSize;
  }

  searchEmit(data: any) {
    this.buscaDocumento(this.data.user.ID, data.filtro);
  }

  changeEvent(event) {
    this.onChangeEvent.emit(event);
  }

  onNew() {
    this.changeEvent({ evento: EVENTO.crearDocumento, data: this.data });
  }

  pageEventPaginator(value) {
    this.pageEvent = value;
    this.listarDocumento(this.data.user.ID, this.sectionBarComponent.filtro);
  }

  buscaDocumento(userID: number, filtro: string) {
    this.clearMatPaginator();
    this.listarDocumento(userID, filtro);
  }


  fabButtonEmit(action: any) {
    switch (action) {
      case ACTIONS.new:
        this.onNew();
        break;
      default:
        break;
    }
  }
  clickButtonEmpty(action: any) {
    switch (action) {
      case ACTIONS.new:
        this.onNew();
        break;
      default:
        break;
    }
  }

  private listarDocumento(userID: number, filtro: string): void {
    this.loaderService.show();
    this.documentoService.listarPorDocumento(userID, filtro, this.pageEvent.pageIndex, this.pageEvent.pageSize)
      .subscribe(res => {
        if (this.errorService.getMessageError(res)) {
          this.dataSource = new GridDataSource(res); //new GridDataSource(res);
          this.showHideMessageGridEmpty(Number(res.length));
          this.pageEvent.length = res.length;
          this.setMatPaginator();
        }
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  public showHideMessageGridEmpty(rows: number) {
    this.showMessageGridEmpty = false;
    if (rows <= 0) this.showMessageGridEmpty = true;
  }
}

